import { render, staticRenderFns } from "./Product.vue?vue&type=template&id=6bca1236"
var script = {}
import style0 from "./Product.vue?vue&type=style&index=0&id=6bca1236&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports